import {
  Col,
  Flex,
  Form,
  Input,
  Modal,
  Select,
  Button,
  Row,
  Typography,
} from "antd";
import React, { useCallback, useEffect } from "react";
import { CustomTitle } from "../../../../../common/customTitle";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { colors } from "../../../../../../constants/colors";
import { routes } from "../../../../../../constants";
import Actions from "../../../../../../redux/actions";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import { offerByID } from "../../../../../../redux/reducers/offerReducer";

const OfferSponsorshipFormDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader] = useState(false);
  /* loading dependencies */

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
  const { selectedOfferId } = useSelector((state) => state.offers);
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  const handleGetTableData = useCallback(() => {
    dispatch(getSystemSettingsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialogClose = () => {
    onClose();
    form.resetFields();
    setSelectedPeriod(null);
    dispatch(offerByID(""));
  };

  const onPeriodChanged = (id) => {
    const selectedPeriodObj = systemSettings?.offer_sponsored_ad_charges?.find(
      (element) => element._id === id
    );
    const tempSelectedPeriodObj = {
      ...selectedPeriodObj,
      currency: systemSettings?.system_currency,
    };
    setSelectedPeriod(tempSelectedPeriodObj);
  };

  /* on submit */
  const onSubmit = () => {
    if (
      selectedOfferId &&
      selectedOfferId !== "" &&
      selectedOfferId !== undefined &&
      selectedOfferId !== null
    ) {
      const dataToBeSent = {
        event_type: "OFFER_SPONSORSHIP_PURCHASE",
        ...selectedPeriod,
        purchase_type: "offer",
      };
      dataToBeSent["_id"] = selectedOfferId;

      dispatch(
        Actions.createAction(
          Actions.SELECTED_OFFERS_AND_PACKAGES_SPONSORSHIP_DETAILS,
          { selectedOffersAndPackagesSponsorshipDetails: dataToBeSent }
        )
      );
      dispatch(Actions.createAction(Actions.CLEAR_COUPON));
      navigate(baseRouteMaker(routes.OFFER_AND_PACKAGES_PAYMENT));
    }
  };
  /* on submit */

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      width={400}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Modules.Offer.OfferForm.addSponsor")}
        </CustomTitle>
      </Flex>
      <Form
        style={{ marginTop: 20 }}
        form={form}
        layout="vertical"
        autoComplete="off"
        requiredMark={false}
        onFinish={onSubmit}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="duration"
              label={
                <RequiredLabel text={t("Modules.Ads.period")} required={true} />
              }
              rules={[
                {
                  required: true,
                  message: t("Modules.Ads.pleaseSelectPeriod"),
                },
              ]}
            >
              <Select
                loading={selectListLoader}
                options={systemSettings?.offer_sponsored_ad_charges?.map(
                  (element) => ({
                    value: element._id,
                    label: `${element.duration} month${
                      element.duration > 1 ? "s" : ""
                    }`,
                    price: `${element.price} ${element.currency}`,
                    currency: systemSettings?.system_currency,
                  })
                )}
                onChange={(value) => onPeriodChanged(value)}
                placeholder={t("Modules.Ads.selectPeriod")}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            {selectedPeriod &&
              selectedPeriod !== null &&
              selectedPeriod !== undefined && (
                <Flex gap="0.8rem">
                  <Typography.Title
                    level={2}
                    style={{
                      color: colors.royalPurple,
                      margin: 0,
                    }}
                  >
                    {selectedPeriod
                      ? `${selectedPeriod?.price} ${selectedPeriod?.currency}`
                      : ""}
                  </Typography.Title>
                  {Number(selectedPeriod?.duration) !== 1 && (
                    <Typography.Title
                      level={5}
                      style={{
                        color: colors.royalPurple,
                        margin: 0,
                        textDecoration: "line-through",
                      }}
                    >
                      {selectedPeriod
                        ? `${
                            selectedPeriod?.duration *
                            systemSettings?.offer_sponsored_ad_charges?.find(
                              (element) => Number(element.duration) === 1
                            )?.price
                          } ${selectedPeriod?.currency}`
                        : ""}
                    </Typography.Title>
                  )}
                </Flex>
              )}
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              {t("CommonUtils.pay")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default OfferSponsorshipFormDialog;
